import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ProcessService } from '../../../core/services/process.service';
import { Process } from '../../../core/models/process.model';
import { AuthService } from '../../../core/services/auth.service';
import { TruncatePipe } from '../../pipes/truncate.pipe';
import { InitialsPipe } from '../../pipes/initials.pipe';
import { LoadingSpinnerComponent } from '../../components/loading-spinner/loading-spinner.component';

@Component({
  selector: 'app-ui-recent-processes',
  standalone: true,
  imports: [CommonModule, RouterModule, TruncatePipe, InitialsPipe, LoadingSpinnerComponent],
  templateUrl: './ui-recent-processes.component.html'
})
export class UiRecentProcessesComponent implements OnInit, OnDestroy {
  public recentProcesses: Process[] = [];
  public loading = false;
  public error = false;

  private destroy$ = new Subject<void>();

  constructor(
    private processService: ProcessService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    this.loadRecentProcesses();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public loadRecentProcesses(): void {
    if (!this.authService.isAuthenticated()) {
      this.error = true;
      return;
    }

    this.loading = true;
    this.error = false;

    this.processService.getProcesses({
      page: 1,
      per_page: 5,
      sort_by: 'created_at',
      sort_order: 'desc'
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          if (response.success && response.data) {
            this.recentProcesses = response.data;
            this.loading = false;
          } else {
            this.error = true;
            this.loading = false;
          }
        },
        error: () => {
          this.error = true;
          this.loading = false;
        }
      });
  }

  public getStatusClass(status: string): string {
    switch (status) {
      case 'Em andamento':
        return 'badge bg-warning/10 !text-warning';
      case 'Concluído':
        return 'badge bg-success/10 !text-success';
      case 'A iniciar':
        return 'badge bg-info/10 !text-info';
      case 'Fechado':
        return 'badge bg-danger/10 !text-danger';
      default:
        return 'badge bg-secondary/10 !text-secondary';
    }
  }
}
